export default [{
    name: 'staff-faqi',
    path: '/staff/faqi',
    meta: {title: '我发起的'},
    component: () => import('./views/faqi')
}, {
    name: 'staff-jieshou',
    path: '/staff/jieshou',
    meta: {title: '我收到的'},
    component: () => import('./views/jieshou')
},
    {
        name: 'staff-consult-faqi',
        path: '/staff/consult/faqi',
        meta: {title: '我发起的'},
        component: () => import('./views/faqi')
    }, {
        name: 'staff-consult-jieshou',
        path: '/staff/consult/jieshou',
        meta: {title: '我收到的'},
        component: () => import('./views/jieshou')
    }, {
        name: 'staff-siji',
        path: '/staff/siji',
        meta: {title: '司机管理'},
        component: () => import('./views/siji')
    }, {
        name: 'staff-cheliang',
        path: '/staff/cheliang',
        meta: {title: '车辆管理'},
        component: () => import('./views/cheliang')
    }, {
        name: 'staff-doc',
        path: '/staff/doc',
        meta: {title: '医生管理'},
        component: () => import('./views/doc')
    }, {
        name: 'staff-hushi',
        path: '/staff/hushi',
        meta: {title: '护士管理'},
        component: () => import('./views/hushi')
    }, {
        name: 'staff-detail',
        path: '/staff/detail',
        meta: {title: '转诊单详情'},
        component: () => import('./views/detail')
    }, {
        name: 'staff-daping',
        path: '/staff/daping',
        meta: {title: '大屏', needLogin: false},
        component: () => import('./views/daping'),
        children: [
            {
                name: 'staff-daping-total',
                path: 'total',
                meta: {title: '全部', needLogin: false},
                component: () => import('./views/daping/total')
            }, {
                name: 'staff-daping-today',
                path: 'today',
                meta: {title: '今日', needLogin: false},
                component: () => import('./views/daping/today')
            },]
    }, /*replace*/];
